import cursor from "./states/CursorState";
import select from "./states/SelectState";
import shift from "./states/ShiftState";
import fadein from "./states/FadeInState";
import fadeout from "./states/FadeOutState";
export default {
  cursor,
  select,
  shift,
  fadein,
  fadeout
};


//////////////////
// WEBPACK FOOTER
// ./~/waveform-playlist/lib/track/states.js
// module id = 1109
// module chunks = 7